import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CmsService, TranslationService } from '@spartacus/core';
import { BreadcrumbComponent, CmsComponentData, CurrentProductService } from '@spartacus/storefront';
import { combineLatest } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { CategoryService } from '../../../../features/services/category.service';
import { AnchorComponent } from '../../anchor/anchor-component';

@Component({
  selector: 'cx-breadcrumb',
  templateUrl: './gg-breadcrumb.component.html',
  styleUrls: ['./gg-breadcrumb.component.scss'],
  standalone: false,
})
export class GgBreadcrumbComponent extends BreadcrumbComponent {
  private cmsService = inject(CmsService);
  private currentProductService = inject(CurrentProductService);
  private categoryService = inject(CategoryService);
  private translationService = inject(TranslationService);
  override router = inject(Router);
  override component = inject(CmsComponentData<AnchorComponent>);

  crumbsCategory$ = combineLatest([
    this.cmsService.getCurrentPage().pipe(
      filter((page) => !!page && !!page.type),
      map((page) => page.type!),
      switchMap((pageType) =>
        pageType === 'CategoryPage'
          ? this.categoryService
              .getCategory(/[^/]*$/.exec(this.router.url)![0].split('?')[0])
              .pipe(map((p) => p?.['firstSuperCategoryHierarchy'].slice(0, -1).reverse()))
          : this.currentProductService
              .getProduct()
              .pipe(
                map((category) =>
                  (category?.ggCategories?.category.slice(1) || []).concat({ name: category?.modelMark })
                )
              )
      )
    ),
    this.translationService.translate('common.home').pipe(take(1)),
  ]).pipe(
    map(([category, textHome]) =>
      category.unshift({ name: textHome, url: '/' }) ? category : [{ name: textHome, url: '/' }]
    )
  );
}
